import { useEffect, useState, type ReactNode } from 'react';
import { Spin } from 'antd';
import { useScreenLoading } from './screenLoading';

export const LOADING_TEXT = 'Loading…';
export const SLOW_LOADING_TEXT = 'Slow network. It opens by itself; keep this page open.';
/** After this long still loading, the screen says a slow signal is the reason. */
export const SLOW_LOADING_MS = 6000;

/**
 * A page (its file, or its first read) still loading: words with the spinner, and after SLOW_LOADING_MS that a slow
 * signal is the reason (round 39, Sunita and Manoj on 2G: a bare spinner read as a blank, stuck page; round 40, Neha:
 * the Quick Pick list's own loading was still a bare spinner). `children` sit under the words (a scan still saving).
 */
export const PageLoading = ({ children }: { children?: ReactNode }) => {
  // A hand-scanner read kept meanwhile waits for this page (screenLoading).
  useScreenLoading();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setSlow(true), SLOW_LOADING_MS);
    return () => window.clearTimeout(timer);
  }, []);
  return (
    <div
      role="status"
      data-testid="page-loading"
      style={{ padding: '48px 16px', textAlign: 'center', fontSize: 18, fontWeight: 600 }}
    >
      <Spin />
      <div style={{ marginTop: 16 }}>{LOADING_TEXT}</div>
      {slow && (
        <div style={{ marginTop: 8, fontSize: 16, fontWeight: 400 }}>{SLOW_LOADING_TEXT}</div>
      )}
      {children}
    </div>
  );
};
